// extracted by mini-css-extract-plugin
export default {"not-expanded":"Footer_not-expanded__kflGe","just-mobile":"Footer_just-mobile__I3+O9","expanded":"Footer_expanded__eAwtX","content":"Footer_content__tUe-I"};